import { call, put, takeLatest, } from 'redux-saga/effects';
import { Urls } from 'src/common/urls';
import * as Actions from './action';
import * as ActionTypes from './actionTypes';
import { NetworkingProvider } from 'src/features/Security/networking/networkingProvider';
import { getErrorFromResponse } from 'src/features/Security/networking/util';

function* getDashboardDataApi(action: Actions.GetDashboardDataAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.REPORT.DASHBOARD_DATA(action.dateFrom, action.dateTo))
        yield put(Actions.getDashboardDataApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getDashboardDataApiError(getErrorFromResponse(err)));
    }
}

export default function* reportSagas() {
    yield takeLatest(ActionTypes.GET_DASHBOARD_DATA_API, getDashboardDataApi)
}